import Modal from '@Common/Modal';
import { PencilSimple } from '@phosphor-icons/react';
import { PromptModalProps } from '@Models/types';

interface ViewPromptModalProps extends PromptModalProps {
  onEdit: () => void;
}

const ViewPromptModal = ({
  isOpen,
  onClose,
  selectedPrompt,
  onEdit,
}: ViewPromptModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={
        selectedPrompt
          ? `View Prompt - Version ${selectedPrompt.version}${selectedPrompt.nickname ? ` - ${selectedPrompt.nickname}` : ''}`
          : 'View Prompt'
      }
    >
      <div className="w-full max-w-4xl">
        {selectedPrompt && (
          <div className="flex flex-col gap-6">
            <div className="grid grid-cols-2 gap-4">
              <div className="flex flex-col gap-2">
                <div>
                  <strong>Version:</strong> {selectedPrompt.version}
                  {selectedPrompt.nickname && <> - {selectedPrompt.nickname}</>}
                </div>
                <div>
                  <strong>Created by:</strong> {selectedPrompt.created_by.name}
                </div>
                <div>
                  <strong>Created on:</strong> {selectedPrompt.date}
                </div>
                {selectedPrompt.is_personal !== undefined &&
                  !selectedPrompt.is_personal && (
                    <div className="flex items-center gap-2">
                      <div className="rounded-full border border-blue-500 bg-blue-100 px-3 py-1 text-sm font-medium text-blue-500">
                        Global Prompt
                      </div>
                    </div>
                  )}
              </div>
            </div>
            <div className="flex flex-col gap-3">
              <strong className="text-lg">Prompt Content:</strong>
              <div className="max-h-96 overflow-y-auto rounded border bg-gray-50 p-4 text-sm">
                <pre className="whitespace-pre-wrap font-mono">
                  {selectedPrompt.content}
                </pre>
              </div>
            </div>
            <div className="flex justify-end gap-3">
              <button
                onClick={() => {
                  onClose();
                  onEdit();
                }}
                className="flex items-center gap-2 rounded bg-green-600 px-4 py-2 text-white hover:bg-green-700"
              >
                <PencilSimple size={16} />
                Edit
              </button>
              <button
                onClick={onClose}
                className="rounded bg-gray-300 px-4 py-2 text-gray-700 hover:bg-gray-400"
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ViewPromptModal;
